import React from "react";
// SCSS
import "./teamInfo.scss";

const about = () => (
  <div className="team__info flex-center">
    <div>
	{/*  <h4 className="font20 weight800">Little About Me</h4> */}
      
     	 
		<ul>
  <li style={{ listStyleType: "disc" }}>Over 25 years experience as an IT Professional.</li>
  <li style={{ listStyleType: "disc" }}>Expertise in solving real world, large scale document management challenges related to complex and diversified content</li>
  <li style={{ listStyleType: "disc" }}>Experience in the architecture, design, development, implementation and delivery of enterprise solutions in the United Kingdom, United States, Canada and Australia.</li>
  <li style={{ listStyleType: "disc" }}>Successful at identifying business problems, creating scalable solutions that can be leveraged by clients, adopted as best practices and integrated within a product offering.</li>
</ul>
    
	{ /* <p className="font12 weight500">Read More</p> */}
    </div>
  </div>
);

export default about;
